module.exports = __webpack_public_path__ + "static/media/circle-right-gray.3c1cae62.svg";